/* eslint-disable react/prop-types */
// import { Box, Typography } from "@mui/material";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { Grid, Box } from "@mui/material";
import moment from "moment";
import { css, StyleSheet } from "aphrodite";
import { getOptions } from "../../../../../utils";
import IntroductionFormApi from "../../../../../services/api/introductionForm";
import InputField from "../../InputField/InputField";
import AutoCompleteDropdown from "../../AutoCompleteDropdown/AutoCompleteDropdown";
import { NEW_ENTRY_FIELDS } from "../../../../../pages/introduction/CreateIntroduction/CreateIntroductionForm/formFields";
import Styles from "./ViewTranferFormStyles";
import { getSubDivisionDisplayName } from "../../../../../utils/helper";

const Style = StyleSheet.create({
  gridItemStyle: {
    "@media (max-width: 768px)": {
      gridColumn: "1 / 3",
    },
  },
  gridContainer: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gridTemplateRows: "1fr",
    gridRowGap: "1.5rem",
    gridColumnGap: "3.75rem",
    "@media (max-width: 768px)": {
      gridRowGap: "1rem",
      gridColumnGap: "1.5rem",
    },
  },
});
function ViewTransferForm({
  handleChange,
  errors,
  values,
  setFieldValue,
  cities,
  states,
  setCities,
  divisions,
  subDivisions,
  setSubDivisions,
  cameFromFriendTransfer,
  cameFromMemberTransfer,
}) {
  const [countries, setCountries] = useState([]);

  const getCountries = async () => {
    const response = await IntroductionFormApi.getCountries();
    setCountries(response.data);
  };

  useEffect(() => {
    getCountries();
  }, []);

  return (
    <Box className={css(Style.gridContainer)}>
      <div style={{ ...Styles.gridItem, ...Styles.name }}>
        <InputField
          required
          label="Name"
          name={NEW_ENTRY_FIELDS.NAME}
          value={values[NEW_ENTRY_FIELDS.NAME]}
          error={errors[NEW_ENTRY_FIELDS.NAME]}
          onChange={handleChange}
          disabled
        />
      </div>
      <Grid className={css(Style.gridItemStyle)}>
        <InputField
          required
          label="Address"
          value={values[NEW_ENTRY_FIELDS.ADDRESS_LINE_1]}
          name={NEW_ENTRY_FIELDS.ADDRESS_LINE_1}
          error={errors[NEW_ENTRY_FIELDS.ADDRESS_LINE_1]}
          onChange={handleChange}
          disabled
        />
      </Grid>
      <Grid style={Styles.gridItem}>
        <InputField
          label="Pincode"
          name={NEW_ENTRY_FIELDS.PINCODE}
          value={values[NEW_ENTRY_FIELDS.PINCODE]}
          onChange={handleChange}
          error={errors[NEW_ENTRY_FIELDS.PINCODE]}
          inputProps={{
            maxLength: 6,
          }}
          disabled
        />
      </Grid>
      {/* <div style={Styles.gridItem}>
        <InputField
          label="Address Line 2"
          name={NEW_ENTRY_FIELDS.ADDRESS_LINE_2}
          value={values[NEW_ENTRY_FIELDS.ADDRESS_LINE_2]}
          onChange={handleChange}
          error={errors[NEW_ENTRY_FIELDS.ADDRESS_LINE_2]}
          disabled
        />
      </div> */}
      <Grid>
        <AutoCompleteDropdown
          getOptionLabel={(option) => option.stateName}
          label="State"
          name={NEW_ENTRY_FIELDS.STATE}
          options={getOptions(states, "stateId")}
          error={errors[NEW_ENTRY_FIELDS.STATE]}
          value={values[NEW_ENTRY_FIELDS.STATE]}
          inputProps={{ required: true }}
          onChange={(selectedValue) => {
            if (!selectedValue) {
              setFieldValue(NEW_ENTRY_FIELDS.STATE, "");
              setCities([]);
            } else {
              setFieldValue(NEW_ENTRY_FIELDS.STATE, selectedValue.value);
              setCities(selectedValue.cities);
            }
            setFieldValue(NEW_ENTRY_FIELDS.CITY, "");
          }}
          disabled
        />
      </Grid>
      <Grid>
        <AutoCompleteDropdown
          getOptionLabel={(option) => option.cityName}
          label="City"
          name={NEW_ENTRY_FIELDS.CITY}
          options={getOptions(cities, "cityId")}
          error={errors[NEW_ENTRY_FIELDS.CITY]}
          value={values[NEW_ENTRY_FIELDS.CITY]}
          disabled={
            !values[NEW_ENTRY_FIELDS.STATE] || values[NEW_ENTRY_FIELDS.STATE]
          }
          inputProps={{ required: true }}
          onChange={(selectedValue) => {
            if (!selectedValue) {
              setFieldValue(NEW_ENTRY_FIELDS.CITY, "");
            } else {
              setFieldValue(NEW_ENTRY_FIELDS.CITY, selectedValue.value);
            }
          }}
        />
      </Grid>
      {/* <div style={Styles.gridItem} /> */}
      <Grid>
        <InputField
          required
          label="Contact Number"
          name={NEW_ENTRY_FIELDS.CONTACT_NUMBER}
          value={values[NEW_ENTRY_FIELDS.CONTACT_NUMBER]}
          onChange={handleChange}
          error={errors[NEW_ENTRY_FIELDS.CONTACT_NUMBER]}
          inputProps={{
            maxLength: 10,
          }}
          disabled
        />
      </Grid>
      <Grid>
        <InputField
          label="Email Address"
          name={NEW_ENTRY_FIELDS.EMAIL_ADDRESS}
          value={values[NEW_ENTRY_FIELDS.EMAIL_ADDRESS]}
          error={errors[NEW_ENTRY_FIELDS.EMAIL_ADDRESS]}
          onChange={handleChange}
          disabled
        />
      </Grid>
      <Grid>
        <AutoCompleteDropdown
          getOptionLabel={(option) => option.name}
          label="Division"
          name={NEW_ENTRY_FIELDS.DIVISION}
          options={getOptions(divisions, "divisionId")}
          error={errors[NEW_ENTRY_FIELDS.DIVISION]}
          value={values[NEW_ENTRY_FIELDS.DIVISION]}
          inputProps={{ required: true }}
          onChange={(selectedValue) => {
            if (!selectedValue) {
              setFieldValue(NEW_ENTRY_FIELDS.DIVISION, "");
              setSubDivisions([]);
            } else {
              setFieldValue(NEW_ENTRY_FIELDS.DIVISION, selectedValue.value);
              setSubDivisions(selectedValue.subDivisions);
            }
            setFieldValue(NEW_ENTRY_FIELDS.SUB_DIVISION, "");
          }}
          disabled
        />
      </Grid>
      <Grid>
        <AutoCompleteDropdown
          getOptionLabel={(option) => getSubDivisionDisplayName(option.name)}
          name={NEW_ENTRY_FIELDS.SUB_DIVISION}
          options={getOptions(subDivisions, "divisionId")}
          error={errors[NEW_ENTRY_FIELDS.SUB_DIVISION]}
          value={values[NEW_ENTRY_FIELDS.SUB_DIVISION]}
          disabled={
            !values[NEW_ENTRY_FIELDS.DIVISION] ||
            values[NEW_ENTRY_FIELDS.DIVISION]
          }
          label="Sub Division"
          onChange={(selectedValue) => {
            if (!selectedValue) {
              setFieldValue(NEW_ENTRY_FIELDS.SUB_DIVISION, "");
            } else {
              setFieldValue(NEW_ENTRY_FIELDS.SUB_DIVISION, selectedValue.value);
            }
          }}
        />
      </Grid>
      {cameFromFriendTransfer || cameFromMemberTransfer ? (
        <Grid>
          <InputField
            label="Date of Joining"
            name={NEW_ENTRY_FIELDS.DATE_OF_JOINING}
            value={
              values[NEW_ENTRY_FIELDS.DATE_OF_JOINING]
                ? moment(values[NEW_ENTRY_FIELDS.DATE_OF_JOINING]).format(
                    "DD/MM/YYYY"
                  )
                : "NA"
            }
            onChange={handleChange}
            error={errors[NEW_ENTRY_FIELDS.DATE_OF_JOINING]}
            disabled
          />
        </Grid>
      ) : null}
      {values[NEW_ENTRY_FIELDS.DIVISION] === 52 ||
      values[NEW_ENTRY_FIELDS.DIVISION] === 53 ? (
        <>
          <Grid>
            <InputField
              required
              label="Parent's Contact Number"
              name={NEW_ENTRY_FIELDS.PARENT_CONTACT_NUMBER}
              value={values[NEW_ENTRY_FIELDS.PARENT_CONTACT_NUMBER]}
              onChange={handleChange}
              error={errors[NEW_ENTRY_FIELDS.PARENT_CONTACT_NUMBER]}
              inputProps={{
                maxLength: 10,
              }}
              disabled
            />
          </Grid>
          <Grid>
            <InputField
              label="Parent's Email Address"
              name={NEW_ENTRY_FIELDS.PARENT_EMAIL_ADDRESS}
              value={values[NEW_ENTRY_FIELDS.PARENT_EMAIL_ADDRESS]}
              error={errors[NEW_ENTRY_FIELDS.PARENT_EMAIL_ADDRESS]}
              onChange={handleChange}
              disabled
            />
          </Grid>
        </>
      ) : null}
      <Grid>
        <AutoCompleteDropdown
          getOptionLabel={(option) => option.countryName}
          name={NEW_ENTRY_FIELDS.NATIONALITY_ID}
          options={getOptions(countries, "countryId")}
          inputProps={{ required: true }}
          error={errors[NEW_ENTRY_FIELDS.NATIONALITY_ID]}
          value={values[NEW_ENTRY_FIELDS.NATIONALITY_ID]}
          label="Nationality/Country"
          onChange={(selectedValue) => {
            setFieldValue(
              NEW_ENTRY_FIELDS.NATIONALITY_ID,
              selectedValue?.value ?? ""
            );
          }}
          disabled
        />
      </Grid>
      {!cameFromFriendTransfer && !cameFromMemberTransfer && (
        <div style={Styles.gridItem} />
      )}
      <Grid>
        <InputField
          required
          label="Introducer's Name"
          name={NEW_ENTRY_FIELDS.INTRODUCED_BY_NAME}
          onChange={handleChange}
          value={values[NEW_ENTRY_FIELDS.INTRODUCED_BY_NAME]}
          disabled
        />
      </Grid>
      <Grid>
        <InputField
          label="Introducer's Contact Number"
          required
          name={NEW_ENTRY_FIELDS.INTRODUCED_BY_MOBILE_NUMBER}
          value={values[NEW_ENTRY_FIELDS.INTRODUCED_BY_MOBILE_NUMBER]}
          onChange={handleChange}
          inputProps={{
            maxLength: 10,
          }}
          disabled
        />
      </Grid>
      <Grid>
        <InputField
          label="Introducer's Email Address"
          name={NEW_ENTRY_FIELDS.INTRODUCED_BY_EMAIL}
          value={values[NEW_ENTRY_FIELDS.INTRODUCED_BY_EMAIL]}
          onChange={handleChange}
          disabled
        />
      </Grid>
      {cameFromMemberTransfer ? (
        <Grid>
          <InputField
            label="Member Leadership"
            name={NEW_ENTRY_FIELDS.POSITION}
            value={
              values?.positions && values?.positions.length > 0
                ? values.positions.find(
                    (position) => position?.positionType === "MAINLINE_POSITION"
                  )?.name ?? "NA"
                : "NA"
            }
            onChange={handleChange}
            disabled
          />
        </Grid>
      ) : null}
    </Box>
  );
}

const propTypes = {
  handleChange: PropTypes.func.isRequired,
  errors: PropTypes.objectOf(PropTypes.string).isRequired,
  values: PropTypes.objectOf(PropTypes.string).isRequired,
  setFieldValue: PropTypes.func.isRequired,
};

ViewTransferForm.propTypes = propTypes;

export default ViewTransferForm;
